import { useEffect, useState } from 'react';
import { opAllowsCat } from '../utils/capabilities';
import { selectableStorages } from '../utils/storageSelectable';

// Shared helpers for the fb-37 create-drawer forms (Production, Consumption, …). Kept tiny + framework-
// only so each form component stays about its own fields/validation/save.
export const today = () => new Date().toISOString().split('T')[0];
export const isFutureDt = d => !!d && d > today();
export const MSG_ERR = ":warn: ";
export const emptyRow = () => ({ item_id: '', qty: '', storage_id: '', notes: '', band_id: '', _status: null });

// selectable storages narrowed to the item's constant (twin of DataEntryPage.filterStoragesForItem)
export function storagesForItem(storages, items, itemId) {
  const live = selectableStorages(storages || []);
  if (!itemId) return live;
  const item = (items || []).find(i => i.id === itemId);
  const cat = item && item.category ? item.category.toLowerCase() : null;
  return cat ? live.filter(s => s.constant_key === cat) : live;
}
// op-capable storages first (opAllowsCat on the storage constant), THEN cross-filter by item
export function storagesForOp(storages, items, itemId, cap, op) {
  const base = (storages || []).filter(s => opAllowsCat(cap, op, s.constant_key));
  return storagesForItem(base, items, itemId);
}
// Map of thunks -> { key: rows }, filled PER KEY as each call returns (twin of DataEntryPage.useApi).
// fb-143: this used to be ONE Promise.all, so the supplier/partner list (a ~300 ms call) waited for the slowest of
// the form's ~8 parallel calls (engine stock-on-hand, bands, accounts: 1-5 s) and a single failed call left EVERY
// picker empty. Each picker now appears as soon as its own call returns; a failed call only empties its own list.
export function useApi(calls) {
  const [data, setData] = useState({});
  useEffect(() => {
    let alive = true;
    Object.entries(calls).forEach(([k, fn]) => {
      Promise.resolve().then(fn).then(v => { if (alive) setData(d => ({ ...d, [k]: v })); }).catch(() => {});
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return data;
}
